<template>
  <v-form>
    <v-container fluid>
      <v-row>


        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="customerSelectItems"
            v-model="item.customer"
            :items="customerSelectItems"
            :error-messages="customerErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.customer')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-autocomplete 
            v-if="customerSelectItems"
            v-model="item.customerLoan"
            :items="customerSelectItems"
            :error-messages="customerLoanErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.customerloan')"
            item-text="name"
            item-value="@id"
            small-chips
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="statusSelectItems"
            v-model="item.status"
            :items="statusSelectItems"
            :error-messages="statusErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.statu')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.location"
            :error-messages="locationErrors"
            :label="$t('qualitycheck.product.location')"
            required
            @input="$v.item.location.$touch()"
            @blur="$v.item.location.$touch()"
          />
        </v-col>
      </v-row>

      <v-row><h2>{{ $t('qualitycheck.product.productcomposition') }}</h2></v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="machineSelectItems"
            v-model="item.machine"
            :items="filteredMachineSelectItems"
            :error-messages="machineErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.machine')"
            item-text="name"
            item-value="@id"
            :disabled="isUniqueProduct && !item.machine"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="toolheadSelectItems"
            v-model="item.toolhead"
            :items="filteredToolheadSelectItems"
            :error-messages="toolheadErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.toolhead')"
            item-text="name"
            item-value="@id"
            small-chips
            :disabled="isUniqueProduct && !item.toolhead"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialSupplySelectItems"
            v-model="item.materialSupply"
            :items="filteredMarerialSupply"
            :error-messages="materialSupplyErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.materialsupply')"
            item-text="name"
            item-value="@id"
            small-chips
            :disabled="isUniqueProduct && !item.materialSupply"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="industrialComputerSelectItems"
            v-model="item.industrialComputer"
            :items="industrialComputerSelectItems"
            :error-messages="industrialComputerErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.industrialcomputer')"
            item-text="name"
            item-value="@id"
            small-chips
            :disabled="isUniqueProduct && !item.industrialComputer"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="controlUnitSelectItems"
            v-model="item.controlUnit"
            :items="controlUnitSelectItems"
            :error-messages="controlUnitErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.controlunit')"
            item-text="name"
            item-value="@id"
            small-chips
            :disabled="isUniqueProduct && !item.controlUnit"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="accessorySelectItems"
            v-model="item.accessory"
            :items="filteredAccessorySelectItems"
            :error-messages="accessoryErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.accessory')"
            item-text="name"
            item-value="@id"
            small-chips
            :disabled="isUniqueProduct && !item.accessory"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="optionSelectItems"
            v-model="item.option"
            :items="filteredOptionSelectItems"
            :error-messages="optionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.option')"
            item-text="name"
            item-value="@id"
            small-chips
            :disabled="isUniqueProduct && !item.option"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="softwareVersionSelectItems"
            v-model="item.softwareVersion"
            :items="filteredSoftwareVersion"
            :error-messages="softwareVersionErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.softwareversion')"
            item-text="name"
            item-value="@id"
            small-chips
            :disabled="isUniqueProduct && !item.softwareVersion"
          />
        </v-col>
      </v-row>
        
        <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="operatingSystemSelectItems"
            v-model="item.operatingSystem"
            :items="filteredOperatingSystem"
            :error-messages="operatingSystemErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('qualitycheck.product.operatingsystem')"
            item-text="name"
            item-value="@id"
            small-chips
            :disabled="isUniqueProduct && !item.operatingSystem"
          />
        </v-col>
      </v-row>
  
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="productchildrenFree"
            v-model="item.products"
            :items="productchildrenFree"
            :error-messages="productsErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            multiple
            :label="$t('qualitycheck.product.productchildren')"
            item-text="name"
            item-value="@id"
            small-chips
          />
        </v-col>
      </v-row>

      <v-row>
        <h2>{{ $t('qualitycheck.product.assembly') }}</h2>
      </v-row>

      <v-row>
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.startAssembly"
            :label="$t('qualitycheck.product.startassembly')"
            :error-messages="startAssemblyErrors"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.endAssembly"
            :label="$t('qualitycheck.product.endassembly')"
            :error-messages="endAssemblyErrors"
          />
        </v-col>

      </v-row>

      <v-row>
        <!-- todo : fix the dateTime format, not supported by default on vuetify -->
        <v-col cols="12" sm="6" md="6">
          <InputDate
            v-model="item.delivery"
            :label="$t('qualitycheck.product.delivery')"
            :error-messages="deliveryErrors"
          />
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.refOrderFab"
            :error-messages="refOrderFabErrors"
            :label="$t('qualitycheck.product.reforderfab')"
            required
            @input="$v.item.refOrderFab.$touch()"
            @blur="$v.item.refOrderFab.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="userAssemblySelectItems"
            v-model="item.userAssembly"
            :items="userAssemblySelectItems"
            :error-messages="userAssemblyErrors"
            :no-data-text="$t('global.no_result')"
:placeholder="$t('global.no_select')"
clearable
            :label="$t('qualitycheck.product.userassembly')"
            item-text="login"
            item-value="@id"
            small-chips
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.link"
            :error-messages="linkErrors"
            :label="$t('qualitycheck.product.link')"
            @input="$v.item.link.$touch()"
            @blur="$v.item.link.$touch()"
          />
        </v-col>
      </v-row>

    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import InputDate from '../InputDate';
import { date } from '../../validators/date';

export default {
  name: 'ProductForm',
  mixins: [validationMixin],
  components: {
    InputDate,
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    defaultvalues: {
      type: Object,
      required: false
    },
    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
      this.customerGetSelectItems();
      this.statusGetSelectItems();
      this.machineGetSelectItems({'orderCol'  : 'order[id]','order'  : 'desc'});
      this.toolheadGetSelectItems({'orderCol'  : 'order[id]','order'  : 'desc'});
      this.materialSupplyGetSelectItems({'orderCol'  : 'order[id]','order'  : 'desc'});
      this.industrialComputerGetSelectItems({'orderCol'  : 'order[id]','order'  : 'desc'});
      this.operatingSystemGetSelectItems({'orderCol'  : 'order[id]','order'  : 'desc'});
      this.controlUnitGetSelectItems({'orderCol'  : 'order[id]','order'  : 'desc'});
      this.accessoryGetSelectItems({'orderCol'  : 'order[id]','order'  : 'desc'});
      this.optionGetSelectItems({'orderCol'  : 'order[id]','order'  : 'desc'});
      this.userAssemblyGetSelectItems({'orderCol'  : 'order[login]','order'  : 'asc'});
      this.softwareVersionGetSelectItems({'orderCol'  : 'order[id]','order'  : 'desc'});
  },
  data() {
    return {
        customer: null,
        status: null,
        location: null,
        machine: null,
        toolhead: null,
        materialSupply: null,
        industrialComputer: null,
        operatingSystem: null,
        controlUnit: null,
        accessory: null,
        option: null,
        userAssembly: null,
        startAssembly: null,
        endAssembly: null,
        delivery: null,
        refOrderFab: null,
        nbproduct: null,
        customerLoan: null,
        softwareVersion: null,
        products: null,
        productchildrenFreeData: null,
        link: null
    };
  },
  computed: {
      isLoading() {
        return (this.isLoading_customer ||
           this.isLoading_productstatus ||
           this.isLoading_machine ||
           this.isLoading_toolhead ||
           this.isLoading_materialsupply ||
           this.isLoading_industrialcomputer ||
           this.isLoading_operatingsystem ||
           this.isLoading_controlunit ||
           this.isLoading_accessory ||
           this.isLoading_option ||
           this.isLoading_softwareversion ||
           this.isLoading_product ||
           this.isLoading_user
         );
      },
      ...mapGetters('product',{
        dataProduct: 'data',
      }),
      ...mapFields('product', {
        updatedata_product: 'updatedata',
        error_product: 'error',
        isLoading_product: 'isLoading',

      }),
      ...mapFields('customer', {
        customerSelectItems: 'selectItems',
        isLoading_customer : 'isLoading'
      }),
      ...mapFields('productstatus', {
        statusSelectItems: 'selectItems',
        isLoading_productstatus : 'isLoading'
      }),
      ...mapFields('machine', {
        machineSelectItems: 'selectItems',
        isLoading_machine : 'isLoading'
      }),
      ...mapFields('toolhead', {
        toolheadSelectItems: 'selectItems',
        isLoading_toolhead : 'isLoading'
      }),
      ...mapFields('materialsupply', {
        materialSupplySelectItems: 'selectItems',
        isLoading_materialsupply : 'isLoading'
      }),
      ...mapFields('industrialcomputer', {
        industrialComputerSelectItems: 'selectItems',
        isLoading_industrialcomputer : 'isLoading'
      }),
      ...mapFields('operatingsystem', {
        operatingSystemSelectItems: 'selectItems',
        isLoading_operatingsystem : 'isLoading'
      }),
      ...mapFields('controlunit', {
        controlUnitSelectItems: 'selectItems',
        isLoading_controlunit : 'isLoading'
      }),
      ...mapFields('accessory', {
        accessorySelectItems: 'selectItems',
        isLoading_accessory : 'isLoading'
      }),
      ...mapFields('option', {
        optionSelectItems: 'selectItems',
        isLoading_option : 'isLoading'
      }),
      ...mapFields('softwareversion', {
        softwareVersionSelectItems: 'selectItems',
        isLoading_softwareversion : 'isLoading'
      }),
      ...mapFields('user', {
        userAssemblySelectItems: 'selectItems',
        isLoading_user : 'isLoading'

      }),

      filteredMachineSelectItems() {
        return this.machineSelectItems.filter(machine => !machine.archive);
      },

      filteredToolheadSelectItems(){
        return this.toolheadSelectItems.filter(toolhead => !toolhead.archive);
      },

      filteredAccessorySelectItems(){
        return this.accessorySelectItems.filter(accessory => !accessory.archive);
      },

      filteredOptionSelectItems(){
        return this.optionSelectItems.filter(option => !option.archive);
      },

      filteredMarerialSupply(){
        return this.materialSupplySelectItems.filter(materialSupply => !materialSupply.archive);
      },

      filteredControlUnit(){
        return this.ControlUnitSelectItems.filter(controlUnit => !controlUnit.archive);
      },

      filteredIndustrialComputer(){
        return this.industrialComputerSelectItems.filter(industrialComputer => !industrialComputer.archive);
      },

      filteredOperatingSystem(){
        return this.operatingSystemSelectItems.filter(operatingSystem => !operatingSystem.archive);
      },

      filteredSoftwareVersion(){
        return this.softwareVersionSelectItems.filter(softwareVersion => !softwareVersion.archive);
      },

      isUniqueProduct(){
        return (
          this.item.machine ||
          this.item.toolhead ||
          this.item.materialSupply ||
          this.item.industrialComputer ||
          this.item.controlUnit ||
          this.item.accessory ||
          this.item.option ||
          this.item.softwareVersion ||
          this.item.operatingSystem
        );
      },
      
      productchildrenFree: {
        get() { return this.productchildrenFreeData },
         set(value) { this.productchildrenFreeData = value; }
      },
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },


    customerErrors() {
      const errors = [];

      if (!this.$v.item.customer.$dirty) return errors;

      has(this.violations, 'customer') && errors.push(this.violations.customer);


      return errors;
    },
    customerLoanErrors() {
      const errors = [];

      if (!this.$v.item.customerLoan.$dirty) return errors;

      has(this.violations, 'customerLoan') && errors.push(this.violations.customerLoan);


      return errors;
    },
    nbproductErrors() {
      const errors = [];
      if (!this.$v.item.nbproduct.$dirty) return errors;
      has(this.violations, 'nbproduct') && errors.push(this.violations.nbproduct);
      return errors;
    },
    statusErrors() {
      const errors = [];

      if (!this.$v.item.status.$dirty) return errors;

      has(this.violations, 'status') && errors.push(this.violations.status);


      return errors;
    },
    locationErrors() {
      const errors = [];

      if (!this.$v.item.location.$dirty) return errors;

      has(this.violations, 'location') && errors.push(this.violations.location);

      !this.$v.item.location.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    machineErrors() {
      const errors = [];

      if (!this.$v.item.machine.$dirty) return errors;

      has(this.violations, 'machine') && errors.push(this.violations.machine);


      return errors;
    },
    toolheadErrors() {
      const errors = [];

      if (!this.$v.item.toolhead.$dirty) return errors;

      has(this.violations, 'toolhead') && errors.push(this.violations.toolhead);


      return errors;
    },
    materialSupplyErrors() {
      const errors = [];

      if (!this.$v.item.materialSupply.$dirty) return errors;

      has(this.violations, 'materialSupply') && errors.push(this.violations.materialSupply);


      return errors;
    },
    industrialComputerErrors() {
      const errors = [];

      if (!this.$v.item.industrialComputer.$dirty) return errors;

      has(this.violations, 'industrialComputer') && errors.push(this.violations.industrialComputer);


      return errors;
    },
    operatingSystemErrors() {
      const errors = [];

      if (!this.$v.item.operatingSystem.$dirty) return errors;

      has(this.violations, 'operatingSystem') && errors.push(this.violations.operatingSystem);


      return errors;
    },
    controlUnitErrors() {
      const errors = [];

      if (!this.$v.item.controlUnit.$dirty) return errors;

      has(this.violations, 'controlUnit') && errors.push(this.violations.controlUnit);


      return errors;
    },
    accessoryErrors() {
      const errors = [];

      if (!this.$v.item.accessory.$dirty) return errors;

      has(this.violations, 'accessory') && errors.push(this.violations.accessory);


      return errors;
    },
    optionErrors() {
      const errors = [];

      if (!this.$v.item.option.$dirty) return errors;

      has(this.violations, 'option') && errors.push(this.violations.option);


      return errors;
    },
    softwareVersionErrors() {
      const errors = [];

      if (!this.$v.item.softwareVersion.$dirty) return errors;

      has(this.violations, 'softwareVersion') && errors.push(this.violations.softwareVersion);


      return errors;
    },
    productsErrors() {
      const errors = [];

      if (!this.$v.item.products.$dirty) return errors;

      has(this.violations, 'products') && errors.push(this.violations.products);


      return errors;
    },
    userAssemblyErrors() {
      const errors = [];

      if (!this.$v.item.userAssembly.$dirty) return errors;

      has(this.violations, 'userAssembly') && errors.push(this.violations.userAssembly);


      return errors;
    },
    startAssemblyErrors() {
      const errors = [];

      if (!this.$v.item.startAssembly.$dirty) return errors;

      has(this.violations, 'startAssembly') && errors.push(this.violations.startAssembly);


      return errors;
    },
    endAssemblyErrors() {
      const errors = [];

      if (!this.$v.item.endAssembly.$dirty) return errors;

      has(this.violations, 'endAssembly') && errors.push(this.violations.endAssembly);


      return errors;
    },
    deliveryErrors() {
      const errors = [];
      if (!this.$v.item.delivery.$dirty) return errors;
      has(this.violations, 'delivery') && errors.push(this.violations.delivery);
      return errors;
    },
    refOrderFabErrors() {
      const errors = [];
      if (!this.$v.item.refOrderFab.$dirty) return errors;
      has(this.violations, 'refOrderFab') && errors.push(this.violations.refOrderFab);
      return errors;
    },
    linkErrors() {
      const errors = [];
      if (!this.$v.item.link.$dirty) return errors;
      has(this.violations, 'link') && errors.push(this.violations.link);
      return errors;
    },
    

    violations() {
      return this.errors || {};
    }
  },
  methods: {
      debugCustomer(d){
        console.log(d)
      },
      ...mapActions({
        customerGetSelectItems: 'customer/fetchSelectItems'
      }),
      ...mapActions({
        statusGetSelectItems: 'productstatus/fetchSelectItems'
      }),
      ...mapActions({
        machineGetSelectItems: 'machine/fetchSelectItems'
      }),
      ...mapActions({
        toolheadGetSelectItems: 'toolhead/fetchSelectItems'
      }),
      ...mapActions({
        materialSupplyGetSelectItems: 'materialsupply/fetchSelectItems'
      }),
      ...mapActions({
        industrialComputerGetSelectItems: 'industrialcomputer/fetchSelectItems'
      }),
      ...mapActions({
        operatingSystemGetSelectItems: 'operatingsystem/fetchSelectItems'
      }),
      ...mapActions({
        controlUnitGetSelectItems: 'controlunit/fetchSelectItems'
      }),
      ...mapActions({
        accessoryGetSelectItems: 'accessory/fetchSelectItems'
      }),
      ...mapActions({
        optionGetSelectItems: 'option/fetchSelectItems'
      }),
      ...mapActions({
        softwareVersionGetSelectItems: 'softwareversion/fetchSelectItems'
      }),
      ...mapActions({
        userAssemblyGetSelectItems: 'user/fetchSelectItems'
      }),
      ...mapActions({
        productDatas: 'product/datas'
      }),
  },
  watch: {
    customerSelectItems() {
      if (this.defaultvalues) {
        if (this.item.customer == null && this.defaultvalues.customerdefault != null) {
          for (var i = 0; i < this.customerSelectItems.length; i++) {
            if (this.customerSelectItems[i].name == this.defaultvalues.customerdefault) {
              this.item.customer = this.customerSelectItems[i];
            }
          }
        }
      }
    },
    statusSelectItems() {
      if (this.defaultvalues) {
        if (this.item.status == null && this.defaultvalues.statutdefault != null) {
          for (var i = 0; i < this.statusSelectItems.length; i++) {
            if (this.statusSelectItems[i].name == this.defaultvalues.statutdefault) {
              this.item.status = this.statusSelectItems[i];
            }
          }
        }
      }
    },
    machineSelectItems() {
      if (this.item.machine) {
        let param = {};


        if(this.item.machine.controlUnit) {
            param.controlUnit = '';
          for (var c = 0; c < this.item.machine.controlUnit.length; c++) {
            if (param.controlUnit != '') param.controlUnit = param.controlUnit +',';
            param.controlUnit = param.controlUnit + this.item.machine.controlUnit[c]['id'];
          }
        }

        if(this.item.machine.industrialComputer) {
            param.industrialComputer = '';
          for (var i = 0; i < this.item.machine.industrialComputer.length; i++) {
            if (param.industrialComputer != '') param.industrialComputer = param.industrialComputer +',';
            param.industrialComputer = param.industrialComputer + this.item.machine.industrialComputer[i]['id'];
          }
        }

        if(this.item.machine.operatingSystem) {
            param.operatingSystem = '';
          for (var o = 0; o < this.item.machine.operatingSystem.length; o++) {
            if (param.operatingSystem != '') param.operatingSystem = param.operatingSystem +',';
            param.operatingSystem = param.operatingSystem + this.item.machine.operatingSystem[o]['id'];
          }
        }

        if(this.item.machine.softwareVersion) {
            param.softwareVersion = '';
          for (var s = 0; s < this.item.machine.softwareVersion.length; s++) {
            if (param.softwareVersion != '') param.softwareVersion = param.softwareVersion +',';
            param.softwareVersion = param.softwareVersion + this.item.machine.softwareVersion[s]['id'];
          }
        }

        console.log(param);

        //this.fetchAllData({'params': params,'data':'notificationProfil'});
        this.productDatas({'data': 'productchildren','params' : param });


      }
    },
    updatedata_product: function (updatedata) {
      if (updatedata == 'productchildren') {
        this.productchildrenFree = this.dataProduct('productchildren');
      }
    },
  },
  validations: {
    item: {
      nbproduct: {
      },
      customer: {
      },
      customerLoan: {

      },
      status: {
      },
      location: {
        required,
      },
      machine: {
      },
      toolhead: {
      },
      materialSupply: {
      },
      industrialComputer: {
      },
      operatingSystem: {
      },
      controlUnit: {
      },
      accessory: {
      },
      option: {
      },
      softwareVersion: {
      },

      userAssembly: {
      },
      startAssembly: {
        date,
      },
      endAssembly: {
        date,
      },
      delivery: {
        date,
      },
      refOrderFab: {

      },
      products: {

      },
      link: {
      }
    }
  }
};
</script>
